import moment from 'moment';
import { ChainStatus } from '@/components/chain-status';
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline';
import { Dragabble } from '@/components/drag-drop';

export function Header({
  container,
  timestamp,
  uuid,
  initialChainStatus,
}: {
  container: string;
  timestamp: string;
  uuid: string;
  initialChainStatus: string;
}) {
  return (
    <div className="flex flex-col text-sm text-gray-400 dark:text-gray-200">
      {uuid && (
        <Dragabble value={[{ uuid, container }]} type="object/insert">
          <button className="z-10 relative nopan">
            <DocumentDuplicateIcon className="h-3.5 w-3.5" aria-hidden="true" />
          </button>
        </Dragabble>
      )}
      <span>UUID: {uuid}</span>
      <span>
        Updated: {moment(timestamp).format('MMM DD, YYYY, h:mm:ss A')}
      </span>
      <div>
        Chain Status:
        <ChainStatus
          uuid={uuid}
          container={container}
          initialStatus={initialChainStatus}
        />
      </div>
    </div>
  );
}
